import { FetchResponse } from '@cian/http-api';
import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  fetchUpdateMailingToggles,
  TUpdateMailingTogglesResponse,
} from '../repositories/discount-about-realty-offer/v1/update-mailing-toggles';
import { addFailedAction } from '../store/failedAction';
import { trackMailingTogglesChange } from '../tracking';
import { IUpdateMailingToggle } from '../types/mailingToggles';

import type { IThunkApi } from '../store';

export const updateMailingToggle = createAsyncThunk<IUpdateMailingToggle, IUpdateMailingToggle, IThunkApi>(
  'mailingToggles/updateMailingToggle',
  async (updateToggle, _thunkApi) => {
    const { fulfillWithValue, rejectWithValue, extra: context, getState, dispatch } = _thunkApi;
    const { httpApi } = context;
    const { toggles } = getState().mailingToggles;

    try {
      const { statusCode }: FetchResponse<TUpdateMailingTogglesResponse> = await fetchUpdateMailingToggles({
        httpApi,
        parameters: { toggles: [updateToggle] },
      });

      if (statusCode === 200) {
        const analyticsName = toggles.find(toggle => toggle.id === updateToggle.id)?.analyticsName;

        if (analyticsName) {
          trackMailingTogglesChange({
            label: updateToggle.isActive ? `${analyticsName}_on` : `${analyticsName}_off`,
          });
        }

        return fulfillWithValue(updateToggle);
      }

      dispatch(addFailedAction({ type: 'IMailingToggleUpdated', payload: updateToggle }));

      return rejectWithValue('Failed to update mailing toggle');
    } catch (error) {
      dispatch(addFailedAction({ type: 'IMailingToggleUpdated', payload: updateToggle }));

      return rejectWithValue('Failed to update mailing toggle');
    }
  },
);
